let currencySymbol = '$';
if (theme.settings.storeCurrency && Shopify) {
  const { currency: { active } } = Shopify;
  const { storeCurrency } = theme.settings;
  const current = storeCurrency.find(({ ISO }) => ISO === active );
  if (current) currencySymbol = current.symbol;
}

const moneyFormat = (amount) => {
  return `${currencySymbol}${(amount / 100).toFixed(2)}`;
}

const timeout = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const fetchCart = async () => {
  try {
    const res = await fetch('/cart.js');
    const data = await res.json();
    if (res.ok) return data;
  } catch (error) {
    console.log(error);
    return null
  }
}

class CartThresholdFST extends HTMLElement {
    constructor() {
      super();
  
      this.enabledTargets = [];
      this.maxTarget = 0;
  
      this.script = this.querySelector('script');
      this.data = this.script ? JSON.parse(this.script.textContent) : null;
      this.enabled = this.data ? this.data.settings.enabled : null;
      if (!this.data || !this.enabled) return;
  
      const [ freeShipping, expressShipping ] = this.data.targets;
      if (freeShipping.value > 0) {
        this.enabledTargets.push(freeShipping);
      }
      if (expressShipping.value > 0) {
        this.enabledTargets.push(expressShipping);
      }
  
      if (!this.enabledTargets.length) return;
      this.enabledTargets = this.enabledTargets.sort((a, b) => a.value - b.value);
  
      const allTargets = this.enabledTargets.map(({ value }) => value);
      this.maxTarget = Math.max(...allTargets);
      if (this.maxTarget === 0) return;
  
      this.#renderElements();
      this.#init();
  
      document.addEventListener('cart:updated', (evt) => {
        const { detail: { cart } } = evt;
        this.#calculateShipping(cart);
      });
    }
  
    #convertToCurrency(amount) {
      return Shopify?.currency?.rate ? Math.trunc(Shopify.currency.rate * +amount) : Math.trunc(+amount)
    }
  
    async #init() {
      const cartData = await fetchCart();
      this.#calculateShipping(cartData);
    }
  
    #renderElements() {
      const target= this.#convertToCurrency(this.maxTarget);
      const renderProgressDots = this.enabledTargets.map(({ name, label, value }, index) => {
        return `
          <span
            class="promo-dots promo--${name} promo--${name}-${index}"
            data-target="${value}"
            data-currency-symbol="${currencySymbol}"
            data-label="${label}"
            aria-hidden="true"
            style="--position: ${(value/this.maxTarget) * 98}">
          </span>
        `
      }).join('');
  
      const html = `
        <div id="cart-promotions-message-success-fst" class="cart-promotions-message-success appear-animation appear-delay-1" style="display: none;"></div>
        <div id="cart-promotions-message-fst" class="cart-promotions-message appear-animation appear-delay-1"></div>
        <div class="cart-promotions-wrapper cart-promotions-wrapper-fst appear-animation appear-delay-1" data-target="${target}" data-currency-symbol="${currencySymbol}">
          <label for="cart-promotions" class="visually-hidden">Cart Promotions - Free shipping</label>
          <progress id="cart-promotions-fst" max="100" value="0" data-target="${target}"></progress>
          <span class="promo-dots promo--value"></span>
          ${renderProgressDots}
        </div>
      `;
  
      this.innerHTML = html;
    }
  
    #calculateShipping(cartJson) {
      let dropshipTotalPrice = 0;
      let noFreeShipping = false
      cartJson.items.forEach(item => {
        if ( item.properties == null) { return; }
        let prop = Object.keys(item.properties)
        if(prop.includes('_no-free-shipping')) {
            noFreeShipping = true;
        }
        if(prop.includes('_dropship')) {
            dropshipTotalPrice += item.final_line_price;
        }
      });

      if (noFreeShipping) {
        document.querySelector('widget-cart-threshold-fst').classList.add('hide');
      } else {
        document.querySelector('widget-cart-threshold-fst').classList.remove('hide');
      }
    
      const targets = this.enabledTargets;
      let total = cartJson.total_price && cartJson.total_price > 0 ? cartJson.total_price : cartJson.final_price && cartJson.final_price > 0 ? cartJson.final_price : 0;
      total -= dropshipTotalPrice;
      const cartTotal = total > 0 ? total / 100 : 0;
      const progressValue = (cartTotal / this.#convertToCurrency(this.maxTarget)) * 100;
      const container = document.getElementById('cart-promotions-fst');
      const outerContainer = document.querySelector('.cart-promotions-wrapper-fst');
      let message = '';
      let messageSuccess = '';

  
      if (progressValue >= 100) {
        container.setAttribute('value', 100);
        container.parentElement.setAttribute('value', 100);
        outerContainer.classList.add('hide');
      } else {
        container.setAttribute('value', progressValue ? progressValue : 0);
        container.parentElement.setAttribute('value', progressValue ? progressValue : 0);
        outerContainer.classList.remove('hide');
      }
  
      if (this.querySelector('.promo--value')) {
        this.querySelector('.promo--value').style.setProperty('--position', progressValue > 100 ? 100 : progressValue);
      }
  
      if (!this.maxTarget) {
        message = 'Please enter target amounts in Theme Settings > Cart Promotions'
        return;
      }
  
      if (cartTotal <= 0) {
        message = this.data.settings.default;
        
      } else {
        for (const [index, target] of targets.entries()) {
          const promoDot = this.querySelector(`.promo--${target.name}-${index}`);
          const remaining = this.#convertToCurrency(target.value) - cartTotal;
  
          if (remaining <= 0) {
            messageSuccess = `<span>${target.messaging.success.replaceAll('[title]', target.title ?? '')}</span><br/>` ?? '';
            if (promoDot) promoDot.classList.add('active');
          } else {
            message += target.messaging.ongoing.replace('[remaining]', `${currencySymbol}${remaining ? remaining.toFixed(2) : target.value.toFixed(2)}`).replaceAll('[title]', target.title ?? '') ?? '';
            if (promoDot) promoDot.classList.remove('active');
            break;
          }
        }
      }
      // Display message
      let messageWrapper = document.getElementById('cart-promotions-message-fst');
      messageWrapper.innerHTML = message;
      message ? messageWrapper.classList.add('show') : messageWrapper.classList.remove('show');

      let successMessageWrapper = document.getElementById('cart-promotions-message-success-fst');
      successMessageWrapper.innerHTML = messageSuccess;
      messageSuccess ? successMessageWrapper.classList.add('show') : successMessageWrapper.classList.remove('show');
    }
}

customElements.define('widget-cart-threshold-fst', CartThresholdFST);

class CartThresholdPromoTiers extends HTMLElement {
  constructor() {
    super();

    this.enabledTargets = [];
    this.maxTarget = 0;

    this.script = this.querySelector('script');
    this.data = this.script ? JSON.parse(this.script.textContent) : null;
    this.enabled = this.data ? this.data.settings.enabled : null;
    this.highest = this.data ? this.data.settings.highest : null;
    if (!this.data || !this.enabled) return;

    const [ tier1, tier2, tier3 ] = this.data.targets;
    if (tier1.value > 0) {
      this.enabledTargets.push(tier1);
    }
    if (tier2.value > 0) {
      this.enabledTargets.push(tier2);
    }
    if (tier3.value > 0) {
      this.enabledTargets.push(tier3);
    }

    if (!this.enabledTargets.length) return;
    this.enabledTargets = this.enabledTargets.sort((a, b) => a.value - b.value);

    const allTargets = this.enabledTargets.map(({ value }) => value);
    this.maxTarget = Math.max(...allTargets);
    if (this.maxTarget === 0) return;

    this.#renderElements();
    this.#init();

    document.addEventListener('cart:updated', (evt) => {
      const { detail: { cart } } = evt;
      this.#calculateShipping(cart);
    });
  }

  #convertToCurrency(amount) {
    return Shopify?.currency?.rate ? Math.trunc(Shopify.currency.rate * +amount) : Math.trunc(+amount)
  }

  async #init() {
    const cartData = await fetchCart();
    this.#calculateShipping(cartData);
  }

  #renderElements() {
    const target= this.#convertToCurrency(this.maxTarget);
    const renderProgressDots = this.enabledTargets.map(({ name, label, value }, index) => {
      return `
        <span
          class="promo-dots promo--${name} promo--${name}-${index}"
          data-target="${value}"
          data-currency-symbol="${currencySymbol}"
          data-label="${label}"
          aria-hidden="true"
          style="--position: ${(value/this.maxTarget) * 98}">
        </span>
      `
    }).join('');

    const html = `
      <div id="cart-promotions-message-success-tiers" class="cart-promotions-message-success appear-animation appear-delay-1"></div>
      <div id="cart-promotions-message-tiers" class="cart-promotions-message appear-animation appear-delay-1"></div>
      <div class="cart-promotions-wrapper cart-promotions-wrapper-tiers appear-animation appear-delay-1" data-target="${target}" data-currency-symbol="${currencySymbol}">
        <label for="cart-promotions" class="visually-hidden">Cart Promotions - Free Gift</label>
        <progress id="cart-promotions-tiers" max="100" value="0" data-target="${target}"></progress>
        <span class="promo-dots promo--value"></span>
        ${renderProgressDots}
      </div>
    `;

    this.innerHTML = html;
  }

  #calculateShipping(cartJson) {
  
    const targets = this.enabledTargets;
    let total = cartJson.total_price && cartJson.total_price > 0 ? cartJson.total_price : cartJson.final_price && cartJson.final_price > 0 ? cartJson.final_price : 0;
    let ignoreGWPTotal = 0;
    cartJson.items.forEach(item => {
      if (item.properties?.["_ignore-gwp"]) {
        ignoreGWPTotal += item.final_line_price;
      }
    })
    const cartTotal = total > 0 ? (total - ignoreGWPTotal) / 100 : 0;

    const progressValue = (cartTotal / this.#convertToCurrency(this.maxTarget)) * 100;	
    const container = document.getElementById('cart-promotions-tiers');	
    const outerContainer = document.querySelector('.cart-promotions-wrapper-tiers');

    let message = '';
    let messageSuccess = '';

    if (progressValue >= 100) {	
      container.setAttribute('value', 100);	
      container.parentElement.setAttribute('value', 100);	
      outerContainer.classList.add('hide');	
    } else {	
      container.setAttribute('value', progressValue ? progressValue : 0);	
      container.parentElement.setAttribute('value', progressValue ? progressValue : 0);	
      outerContainer.classList.remove('hide');	
    }

    if (this.querySelector('.promo--value')) {	
      this.querySelector('.promo--value').style.setProperty('--position', progressValue > 100 ? 100 : progressValue);	
    }


    if (!this.maxTarget) {
      message = 'Please enter target amounts in Theme Settings > Cart Promotions'
      return;
    }

    if (cartTotal <= 0) {
      message = '';
      
    } else {
      for (const [index, target] of targets.entries()) {
        const promoDot = this.querySelector(`.promo--${target.name}-${index}`);
        const remaining = this.#convertToCurrency(target.value) - cartTotal;

        if (remaining <= 0) {
          messageSuccess = `<span>${target.messaging.success.replaceAll('[title]', target.title ?? '')}</span><br/>` ?? '';
          if (promoDot) promoDot.classList.add('active');
        } else {
          message += target.messaging.ongoing.replace('[remaining]', `${currencySymbol}${remaining ? remaining.toFixed(2) : target.value.toFixed(2)}`).replaceAll('[title]', target.title ?? '') ?? '';
          if (promoDot) promoDot.classList.remove('active');
          break;
        }
      }
    }

    // Display message
    let messageWrapper = document.getElementById('cart-promotions-message-tiers');
    messageWrapper.innerHTML = message;
    message ? messageWrapper.classList.add('show') : messageWrapper.classList.remove('show');

    let successMessageWrapper = document.getElementById('cart-promotions-message-success-tiers');
    successMessageWrapper.innerHTML = messageSuccess;
    messageSuccess ? successMessageWrapper.classList.add('show') : successMessageWrapper.classList.remove('show');

    // document.getElementById('cart-promotions-message-tiers').innerHTML = message;
    // document.getElementById('cart-promotions-message-success-tiers').innerHTML = messageSuccess;
  }
}

customElements.define('widget-cart-threshold-tiers', CartThresholdPromoTiers);